import * as types from '@/store/mutation-types'
import { Repository } from '@/repository/repository'
import { services } from '@/services'

const apiRepository = Repository.call('messages')

const state = {
  show: false,
  messages: []
}

const getters = {
  show: state => state.show,
  content: state => state.messages
}

const actions = {
  async launchMessageModal ({ commit }, objIds) {
    const {
      id,
      customerOrderCode,
      userCode
    } = objIds

    const messages = await apiRepository.getActiveMessages(id)
    if (!messages.level) return messages

    const cleanResponse = services.cleanResponseService(messages.data)
    const postMessages = {
      id,
      userCode,
      customerOrderCode,
      messages: cleanResponse
    }

    commit(types.LAUNCH_MAILBOX_MODAL, postMessages)
  },
  async sendMessage ({ commit }, data) {
    const {
      id,
      message
    } = data

    const params = {
      customerOrder: {
        id
      },
      message
    }

    const send = await apiRepository.sendMessages(params)
    return send
  },
  flush ({ commit }) {
    commit(types.SET_FLUSH_MAILBOX_MODAL)
  },
  enable ({ commit }) {
    commit(types.START_MAILBOX_MODAL)
  },
  disable ({ commit }) {
    commit(types.STOP_MAILBOX_MODAL)
  }
}

const mutations = {
  [types.LAUNCH_MAILBOX_MODAL] (state, messages) {
    state.show = true
    state.messages = messages
  },
  [types.SET_FLUSH_MAILBOX_MODAL] (state) {
    state.messages = []
  },
  [types.START_MAILBOX_MODAL] (state) {
    state.show = true
  },
  [types.STOP_MAILBOX_MODAL] (state) {
    state.show = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/messages.js